
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retirement-planning/kai-zen",
      function () {
        return require("private-next-pages/retirement-planning/kai-zen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retirement-planning/kai-zen"])
      });
    }
  